import { Col, Row } from "react-bootstrap"

const CaviarBuild = () =>{
    
    return <> <h1>How to build CAVIAR</h1>
      
    <p>CAVIAR comes SMD pre-soldered. If you have a DIY version you will need to finish the build by soldering the remaining through hole parts:</p>
    <p>The full list of required components and reasoning is here:</p>
    <table>
        <tr>
        <th>Name  </th>
        <th>Quantity  </th>
        <th>Mandatory</th>
        <th>Source </th>
        <th>Details</th>
        </tr>
        <tr>
          <td>Mono 3.5mm Jacks (thonkiconn)</td>
          <td>9</td>
          <td>Yes</td>
          <td>
          <a href="https://www.taydaelectronics.com/pj-3001f-3-5-mm-mono-phone-jack.html">Tayda: PJ-3001F</a><br/>
          <a href="https://www.thonk.co.uk/shop/thonkiconn/">Thonk: Thonkiconn PJ398SM</a>
          </td>
          <td>The ones just about everyone uses</td>
        </tr>
        <tr>
          <td>Shrouded 2x5 pin header</td>
          <td>1</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a><br/>
            <a href = "https://www.taydaelectronics.com/10-pin-box-header-connector-2-54mm.html">Tayda</a>
          </td>
          <td>Can use unshrouded pins if you live fast and loose, the module has input protection</td>
        </tr>
        <tr>
          <td>PTL45: 45mm LED slider</td>
          <td>2</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.digikey.co.uk/en/products/detail/bourns-inc/PTL45-15O0-104A3/3781310">Digikey</a><br/>
            <a href = "https://www.mouser.co.uk/ProductDetail/Bourns/PTL45-15R0-103B2?qs=XxajcJZMfNwybdu%2Fz5bMWA%3D%3D">Mouser</a>
          </td>
          <td>
            linear taper, any resistance more than 10k will do. Centre detent preferable.
          </td>
        </tr>
        <tr>
          <td>5/6mm M2 Screws</td>
          <td>12</td>
          <td>Can be bothched</td>
          <td></td>
          <td>For binding sliders to front panel. The little kits you can get on eBay will have something that works</td>
        </tr>
        <tr>          
          <td>2/3mm M2 spacers</td>
          <td>4</td>
          <td>Can be bothched</td>
          <td></td>
          <td>For binding sliders to front panel - 3mm recommended - screw needs to pass through 1.6mm boards, spacer, and <b>partially</b> into slider</td>
        </tr>
        <tr>
          <td>2.54mm box pin male headers</td>
          <td>15</td>
          <td>No</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a> <br/>
            <a href = "https://www.taydaelectronics.com/12-pin-2-54-mm-single-row-pin-header-strip.html">Tayda</a>
          </td>
          <td>For binding panels</td>
        </tr>
        <tr>
        <td>stackable 1x15 2.54mm Female Header pins</td>
        <td>1</td>
        <td>Non-stackable fine if you aren't interested in the planned stero panningexpander</td>
        <td>  <a href = "https://www.taydaelectronics.com/stackable-header-12-pins-2-54mm.html">Tayda (15 pin not available to you'll have to get creative)</a></td>
        </tr>
        <tr>
          <td>11mm M2 spacer</td>
          <td>2</td>
          <td>No</td>
          <td>
          </td>
          <td>for binding Boards. could be approximated by stacking smaller spacers and washers
          </td>
        </tr>
      </table>
      <br></br>
    <h2>Lets Go!</h2>
      <p>There aren't many steps, promise!</p>
    <Col>
      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 1:</h4>
        <p>You may recieve the 2 boards as one PCB seperated by mousebites. All you need to do is snap them out and trim the edges just like your warhammer kits</p>
        </Col> 
        <Col>
          <img src="/CAVIAR DIY/step0.jpg" style={{width:"20rem"}}></img>
        </Col>
        <Col>
          <img src="/CAVIAR DIY/step0_1.jpg" style={{width:"20rem"}}></img>
        </Col>

      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"30rem"}}>
        <h4>Step 2:</h4>
        <p>the ptl45 slider is a bit of a pain, if the moutning screw goes too far in then it get's in the way of the slider!</p>
        <p>I've found the ideal mounting method is a shorter 6mm M2 screw which passes through a 3mm standoff</p>
        <p>To make that work you first need to bolt the slider to the faceplate. Easiest method is to do the standoff first then loosen and retighten to bite into the slider.</p>
        <p>Please try not bed the pins or you're in for a bad time!</p>
        </Col> 
        <Col>
          <img src="/CAVIAR DIY/step1_1.jpg" style={{height:"50vh"}}></img>
        </Col>
        <Col>
          <img src="/CAVIAR DIY/step_1_2.jpg" style={{height:"50vh"}}></img>
        </Col>
        <Col>
          <img src="/CAVIAR DIY/step_1_3.jpg" style={{height:"50vh"}}></img>
        </Col>
      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 3:</h4>
        <p>Now Solder the power header to the back board</p>
        </Col> 
        <Col>
          <img src="/CAVIAR DIY/step_2_1.jpg" style={{width:"20rem"}}></img>
        </Col>

      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 4:</h4>
        <p>To ensure the front and back board headers are aligned we should temporarily bind them using the 11mm spacer and solder bothe headers at the same time.</p>
        <p></p>
        </Col> 
        <Col>
          <Row><img src="/CAVIAR DIY/step_3_1.jpg" style={{width:"20rem"}}></img></Row>
          <Row><img src="/CAVIAR DIY/step_3_2.jpg" style={{width:"20rem"}}></img></Row>
          <Row><img src="/CAVIAR DIY/step_3_3.jpg" style={{width:"20rem"}}></img></Row>
        </Col>
          
      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 5:</h4>
        <p>Now seperate the boards and solder the interface components.</p>
        <p>Place the jacks on first then the faceplate (with mounted sliders) to align everything then solder.</p>
        <p>Please make sure everything is where it needs to be because removing the panel can be tricky. That includes those spacers!</p>
        <p></p>
        </Col> 
          <Col><img src="/CAVIAR DIY/step_4_1.jpg" style={{width:"15rem"}}></img></Col>

        <Col><img src="/CAVIAR DIY/step_4_2.jpg" style={{width:"15rem"}}></img></Col>
      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 6:</h4>
        <p>Now re-atach the interface+faceplate to the main board.</p>
        <p></p>
        </Col> 
          <Col><img src="/CAVIAR DIY/step_5_1.jpg" style={{width:"15rem"}}></img></Col>

        <Col><img src="/CAVIAR DIY/step_5_2.jpg" style={{width:"15rem"}}></img></Col>
      </Row>
      <Row style={{margin:"4rem"}}></Row>

      <Row style={{}}>
        <Col style={{minWidth:"20rem"}}>
        <h4>Step 7 - Testing and Tuning:</h4>
        <p>Use your multimeter to check for shorts. if it's all good plug it in and power on!</p>

        <p>Each unit has 3 trimmers, getting these right means equal power across the whole range and helps centre the detent.
           If it's good then you should have something close to silent when the slider is centred when 4 quadrant multiplying</p>
        
        <p>The main board includes a trimmer for the gain of the 2 VCAs which make a crossfader unit. Move the slider all the way up to the top or bottom and adjust the appropriate trimmer until you get 5V out.</p>
        <p>Balance on the inerface board applies a small offset for the sliders CV (U1 balance and U2 balance). Put the slider to center position and adjust the balance until you have a signal that's as close to zero as you can get.</p>
        <p>Changing gain will change the balance and vice versa so you'll need to iteratively tune until you're happy.</p>
        <p>Temperature sensitvity means it'll never be perfect so you stop when it's acceptable. I've been able to bring it down to 10mV noise at zero!</p>
        </Col> 
          <Col><img src="/CAVIAR DIY/step_6.jpg" style={{width:"15rem"}}></img></Col>

      </Row>
      <Row style={{margin:"4rem"}}></Row>
    </Col>
    

  <h2>Tidbits</h2>
    <h3>bi-colour LEDs</h3>
    <p>The LEDs of the PTL slider are very easily replaceable by just pulling them out, you can replace them with any colour you like, including a bi-colour LED if you can find one.</p>
</>
}

export default CaviarBuild